import React from 'react'
import './services.css'
import {BsCheck2Circle} from 'react-icons/bs'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>AI Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Machine Learning Models</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Data Analysis & Visualization</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Predictive Analytics</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>AI Consulting</p>
            </li>

          
          </ul>
        </article>
        {/* ///////////////////////////////////////////////////////////////////////////////// */}
        <article className="service">
          <div className="service__head">
            <h3>MERN Stack eCommerce Development</h3>
          </div>

          <ul className="service__list">
            {/* <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Custom eCommerce Solutions using MongoDB, Express.js, React, and Node.js</p>
            </li> */}
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Full-Stack Development including User Panel, Admin Panel, frontend, backend, and database integration</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Shopping Cart Integration</p>
            </li>
            {/* <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Payment Gateway Integration</p>
            </li> */}
            
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Responsive Design & User Experience Optimization</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p>Performance Tuning and Security Enhancement</p>
            </li>

          </ul>
        </article>
        {/* ///////////////////////////////////////////////////////////////////////// */}
        <article className="service">
          <div className="service__head">
            <h3>Small Project Assistance</h3>
          </div>

          <ul className="service__list">
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p> Help with Personal and Academic Projects</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p> Guidance on Project Planning and Execution</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p> Development Support for Smaller Scale Applications</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p> Troubleshooting and Debugging</p>
            </li>
            <li>
              <BsCheck2Circle className='service__list-icon'/>
              <p> Code Review and Optimization</p>
            </li>
          </ul>
        </article>
        {/* ///////////////////////////////////////////////////////////////////////// */}
      </div>
    </section>
  )
}

export default Services
